import MainLayout from "@/components/layout/admin/MainLayout.vue";
import store from "../../../store";
import axios from "axios";
import { required, maxLength, requiredIf } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Select2Multiple from "v-select2-multiple-component";
import ValidationService from "@/services/ValidationService";

export default {
  name: "DiscountTypeCreate",
  components: { MainLayout, Loading, Select2Multiple },
  mixins: [ValidationService],
  data() {
    return {
      isLoading: false,
      submitted: false,
      disabled: false,
      campus_id: null,
      discount_name: "",
      discount_type: null,
      discount_amount: "",
      discount_description: "",
      discount_category: "none",
      student_ids: [],
      studentOptions: [],
      is_active: 1
    };
  },

  computed: {
    requiresStudents() {
      return this.discount_category === "special" || this.discount_category === "lifetime";
    }
  },

  validations: {
    discount_name: { required, maxLength: maxLength(255) },
    discount_type: { required },
    discount_amount: {
      required,
      validValue(value) {
        if (value === null || value === undefined || value === '') return true;
        if (this.discount_type === 1) {
          return value > 0 && value <= 100;
        }
        if (this.discount_type === 2) {
          return value > 0;
        }
        return true;
      }
    },
    discount_description: { maxLength: maxLength(1000) },
    is_active: { required },
    student_ids: {
      required: requiredIf(function () {
        return this.requiresStudents;
      })
    }
  },

  mounted() {
    this.campus_id = store.state.user.campus_id;
    this.loadStudents();
  },

  methods: {
    // Prevent non-numeric input in discount_amount
    preventKeys(e) {
      if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
        e.preventDefault();
      }
    },

    onCategoryChange() {
      if (!this.requiresStudents) {
        this.student_ids = [];
      }
    },

    // Load students for Select2Multiple dropdown
    loadStudents() {
      this.isLoading = true;
      axios.get(`/student/dropdown`, { params: { campus_id: this.campus_id } })
        .then(res => {
          this.studentOptions = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => {
          console.error("Failed to load students:", err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    confirmRegister() {
      this.submitted = true;
      this.disabled = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }
      this.register();
    },

    register() {
      const isSpecial = this.requiresStudents;
      const isLifetime = this.discount_category === "lifetime";
      const request = {
        campus_id: this.campus_id,
        name: this.discount_name,
        discount_type: this.discount_type,
        discount_amount: this.discount_amount,
        discount_description: this.discount_description,
        is_special_discount: isSpecial ? 1 : 0,
        is_lifetime: isLifetime ? 1 : 0,
        student_ids: isSpecial ? this.student_ids.map(id => Number(id)) : [],
        is_active: this.is_active ? 1 : 0,
        created_id: store.state.user.id
      };
      axios.post("/discountType/create", request)
        .then(() => {
          this.$notification.success("Discount Type created successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({ name: "discountTypeList" });
        })
        .catch(error => {
          this.disabled = false;
          if (error.response?.status === 422) {
            this.printValidationError(error.response);
            if (!Object.keys(error.response.data?.errors || {}).length) {
              this.$notification.error("Please check the form errors.", {
                timer: 5,
                position: "bottomCenter"
              });
            }
            console.error("Validation Error:", error.response.data.errors);
          } else if (error.response?.status === 401) {
            store.commit("logout");
            window.location.replace("login");
          } else {
            console.error("Unexpected error:", error);
          }
        });
    },

    showList() {
      this.$router.push({ name: "discountTypeList" });
    }
  }
};
